const PHRASES = [
  "Celebrated Glutathione Brand",
  "Clinical Precision",
  "Premium Ingredients",
  "Glow From Within",
  "Cost-Effective Luxury",
];

export default function Marquee() {
  const items = [...PHRASES, ...PHRASES];
  return (
    <section
      data-testid="marquee-section"
      className="relative z-10 border-y border-champagne bg-surface py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {items.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl font-light text-[color:var(--relumia-ink)] px-8">
              {p}
            </span>
            <span className="text-gold text-lg">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
